import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { About_url, AllBlogs_url, Contact_url, Privacy_url } from "../../constants";
import styles from "./style.module.css";
import { useSelector } from "react-redux";

const Menus = () => {
  const collapseRef = useRef(null);
  const loggedInUser = useSelector((state) => state.auth.user);

  const location = useLocation();

  const isActive = (item) => {
    const { pathname } = location;
    const itemUrl = new URL(item.link, window.location.origin);
    const itemPath = itemUrl.pathname;

    if (itemPath === "/search") {
      return pathname === "/search";
    }

    return pathname === itemPath;
  };

  useEffect(() => {
    const href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    // console.log("href", href);

    const element = document.getElementById(href);
    // console.log("href element", element);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const menus = [
    {
      id: 1,
      name: "Home",
      link: "/",
      isBold: "bold",
    },
    {
      id: 2,
      name: "Find a Teacher",
      link: "/search?query=&gender=&modeOfTeaching=&cityId=&areaId=&course-level=&qualification-level=&education-board=&page=1",
      isBold: "",
    },
    // {
    //   id: 3,
    //   name: "Become a Teacher",
    //   link: "",
    //   isBold: "",
    // },
    {
      id: 3,
      name: "Blog",
      link: AllBlogs_url,
      isBold: "",
    },
    // {
    //   id: 4,
    //   name: "Free Learnding",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 5,
    //   name: "Scholerships",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 6,
    //   name: "Community Service",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 7,
    //   name: "Advertise With Us",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 8,
    //   name: "Invertor Relation",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 9,
    //   name: "Merchendise",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 10,
    //   name: "Blogs",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 11,
    //   name: "Privacy Policy",
    //   link: Privacy_url,
    //   isBold: "",
    // },
    {
      id: 12,
      name: "Contact Us",
      link: Contact_url,
      isBold: "",
    },
    {
      id: 13,
      name: "About Us",
      link: About_url,
      isBold: "",
    },
  ];

  const handleItemClick = () => {
    if (collapseRef.current) {
      collapseRef.current.classList.remove("show");
    }
  };
  return (
    <>
      {menus?.map((item) => {
        /* if (loggedInUser?.role === "teacher" && item.name === "Find a Teacher") {
          return null; // Skip "Find a Teacher" for teachers
        } */
        return (
          <li
            key={item?.id}
            className={`nav-item ${styles?.customFont}`}
            onClick={handleItemClick}
          >
            <Link
              className={`nav-link text-black ${
                isActive(item) ? "fw-bold" : ""
              }`}
              style={{fontSize: "14px"}}
              aria-current="page"
              to={item?.link}
            >
              {item?.name}
            </Link>
          </li>
        );
      })}
    </>
  );
};

export default Menus;
